import React from "react";
import {Row, Col, Radio, Form, Tabs} from "antd";
import MoneyInputWithCurrencySelector from "components/MoneyInputWithCurrencySelector";
import TransferDetailsPanel from "components/transfercalculator/TransferDetailsPanel";
import LoadingIndicator from "components/LoadingIndicator";
import { getTransferCalculatorConfiguration } from "api/api";

import "./ClientTransferCalculator.scss";
import {formatExchangeRate, formatMoney, displayNumberWithComma} from "../../utils/utils";
import {displayError, displayGenericError} from "../../common/notifications";
import {
  getCountryList,
  getCurrentCustomer,
  getTransactionLimitations,
  getTransferCalculatorConfigurationWithConvertAmount
} from "../../api/api";
import Icon from "antd/es/icon";
import moment from "moment";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";
import RadioGroup from "antd/es/radio/group";
import BrdgxCountrySelector from "../selector/BrdgxCountrySelector";
import "./ClientTransferCalculator.scss";
import CurrencySelector from "../CurrencySelector";

const SEND_AMOUNT_MIN = 10
const SEND_AMOUNT_MAX = 500 * 1000
const STANDARD_CURRENCY_FEE = ["SGD", "USD", "EUR", "GBP", "AUD"]
const BETA_TARGET_CURRENCY = ["SGD", "MYR","HKD","CNY","IDR","PHP","VND","THB","USD","AUD"]

class ClientTransferCalculator extends React.Component {
  state = {
    sourceValue: this.props.transfer ? this.props.transfer.sourceValue : {},
    targetValue:  this.props.transfer ? this.props.transfer.targetValue : {},
    allowedSourceCurrencies: [],
    allowedTargetCurrencies: [],
    transferMode: "SOURCE",
    isConfigurationLoading: true,
    exchangeRates: null,
    factors:{},
    feeType:'FIXED',
    fixedFeeAmount: 10,
    feePercentageAmount:0,
    minimumFeeFixedAmount:0,
    transactionLimitation:[],
    errorMsgTargetAmount:"",
    baseCurrency:'SGD',
    beneficiaryType :  this.props.transfer ? this.props.transfer.beneficiaryType : 'PERSONAL',
    senderType :  this.props.transfer ? this.props.transfer.senderType : 'PERSONAL',
    displaySelectBeneficiaryType: this.props.transfer? this.props.transfer.displaySelectBeneficiaryType : true,
    displaySelectSenderType: this.props.transfer? this.props.transfer.displaySelectSenderType : true,
    displaySelectBeneficiaryCountry: this.props.transfer? this.props.transfer.displaySelectBeneficiaryCountry : true,
    beneficiaryCountries:[],
    beneficiaryCountry :  this.props.transfer ? this.props.transfer.beneficiaryCountry : '',
    countries:[],
    initData: true,
  };
  componentWillUnmount() {
    clearInterval(this.intervalId);
  }
  componentDidMount() {
    getCountryList()
        .then(response => {
          let OTHERS = {country: "OTHERS",
            countryCode: "OTHERS",
            isoCodeAlpha2:"SG",
            localCurrency: "SGD"}
          response.push(OTHERS)
          this.setState({
            countries: response
          });
        })
        .catch(error => {
          displayGenericError(error);
        });
    getCurrentCustomer()
        .then(response => {
          this.setState({
            senderType: response.accountType,
            baseCurrency: response.companyProfile.baseCurrency
          }, () => {
            this.loadTransferCalculatorConfiguration();
            this.intervalId = setInterval(activeTabFee => this.loadTransferCalculatorConfiguration(), 300000);
          })

        })
        .catch(error => {
          displayGenericError(error);
        });

  }

  // componentDidUpdate(prevProps, prevState) {
  //   const { selectedTransferRoute, sourceValue, exchangeRates } = this.state;
  //   if (prevState.exchangeRates !== this.state.exchangeRates) {
  //     const newTargetValue = this.calculateTargetValueFromSourceValue(
  //       selectedTransferRoute,
  //       sourceValue,
  //       exchangeRates
  //     );
  //     this.setState({
  //       targetValue: newTargetValue
  //     });
  //   }
  // }

  onConfigurationLoaded = newConfigurationResponse => {
    let newAllowedSourceCurrencies = [];
    let currentUser = this.props.currentCustomer;
    if(currentUser && currentUser.sourceCurrency){
      newAllowedSourceCurrencies = currentUser.sourceCurrency.split(",")
    }else{
      for (let i = 0; i < newConfigurationResponse.transferRoutes.length; i++) {
        let transferRoute = newConfigurationResponse.transferRoutes[i];
        // if (!newAllowedSourceCurrencies.includes(transferRoute.sourceCurrency) &&  (transferRoute.sourceCurrency === 'SGD' || transferRoute.sourceCurrency === 'USD' || transferRoute.sourceCurrency === 'HKD'   ||
        //     transferRoute.sourceCurrency === 'CAD' || transferRoute.sourceCurrency === 'IDR')) {
        if (!newAllowedSourceCurrencies.includes(transferRoute.sourceCurrency) ) {
          newAllowedSourceCurrencies.push(transferRoute.sourceCurrency);
        }
      }
    }

    let sourceDefaultCurrency ='SGD';
    let targetDefaultCurrency ='MYR';


    let isPartner = null;
    if (currentUser && currentUser.customerTierName && currentUser.customerTierName.includes('PARTNER')) {
      isPartner=true;
    }
    if(isPartner) {
      sourceDefaultCurrency='USD';
      targetDefaultCurrency ='USD';
    } else if (this.state.baseCurrency === 'HKD') {
      sourceDefaultCurrency = 'HKD';
      targetDefaultCurrency = 'USD';
    }
    else if (this.state.baseCurrency === 'SGD') {
      sourceDefaultCurrency = 'SGD';
      targetDefaultCurrency = 'MYR';
    }else if (this.state.baseCurrency === 'MYR') {
      sourceDefaultCurrency = 'MYR';
      targetDefaultCurrency = 'USD';
    }

    let initialTransferRoute = this.props.transfer
        ? this.props.transfer.transferRoute
        :  newConfigurationResponse.transferRoutes.filter(s=>s.sourceCurrency === sourceDefaultCurrency && s.targetCurrency ===targetDefaultCurrency)[0]
    let initialSourceValue = this.props.transfer
      ? this.props.transfer.sourceValue
      : { amount: 1000, currency: initialTransferRoute.sourceCurrency };
    let allowedTargetCurrencies = this.calculateAllowedTargetCurrencies(
      newConfigurationResponse.transferRoutes,
      initialSourceValue
    );
    let initialTargetValue = this.props.transfer
      ? this.props.transfer.targetValue
      : this.calculateTargetValueFromSourceValue(
          initialTransferRoute,
          initialSourceValue,
          newConfigurationResponse.rates
        );
    let newTransferRoute = this.findTransferRoute(newConfigurationResponse.transferRoutes, initialSourceValue.currency,initialTargetValue.currency)
    if (newTransferRoute.beneficiaryCountries && newTransferRoute.beneficiaryCountries.length >= 1) {

      let countries = this.state.countries.filter(s => newTransferRoute.beneficiaryCountries.includes(s.countryCode))
      this.setState({
        beneficiaryCountries: countries,

      });
      //init beneficiary country
      if (!this.state.beneficiaryCountry) {
        this.setState({
          beneficiaryCountry: newTransferRoute.beneficiaryCountries[0],

        });
      }


    }
    this.setState(
      {
        transferRoutes: newConfigurationResponse.transferRoutes,
        allowedSourceCurrencies: newAllowedSourceCurrencies,
        allowedTargetCurrencies: allowedTargetCurrencies,
        //allowedTargetCurrencies: BETA_TARGET_CURRENCY,
        sourceValue: initialSourceValue,
        targetValue: initialTargetValue,
        selectedTransferRoute: newTransferRoute,
        exchangeRates: newConfigurationResponse.regularRates,
        factors:newConfigurationResponse.factors,
        transferMode: this.props.transfer
          ? this.props.transfer.transferMode
          : "SOURCE",
        minimumFeeFixedAmount:newTransferRoute.minimumFeeFixed,
        feeType: newTransferRoute.feeType,
        fixedFeeAmount: newTransferRoute.feeFixed,
        feePercentageAmount: newTransferRoute.feePercent ? formatMoney(newTransferRoute.feePercent * 100) : 0,
      },
      function() {
        if(this.state.feePercentageAmount != null &&  this.state.feePercentageAmount != 0){
          this.state.selectedTransferRoute.feePercent =formatExchangeRate(this.state.feePercentageAmount/100);
        }
        if(this.props.transfer === null || this.props.transfer.transferMode === 'SOURCE' ){
          //just recalculate target amount in first time
          const newTargetValue = this.calculateTargetValueFromSourceValue(
              this.state.selectedTransferRoute,
              this.state.sourceValue,
              this.state.exchangeRates
          );
          this.setState({
            targetValue: newTargetValue
          },()=>{
            this.fireChanged();
          });
        }else{

            const newSourceValue = this.calculateSourceValueFromTargetValue(
                this.state.selectedTransferRoute,
                this.state.sourceValue.currency,
                this.state.targetValue
            );
            this.setState({
              sourceValue: newSourceValue
            },()=>{
              this.fireChanged();
            });
          }

        //  this.fireChanged();
        }

    );
  };

  calculateAllowedTargetCurrencies = (transferRoutes, sourceValue) => {
    let allowedTargetCurrencies = [];
    let prioritizeCurrencies = [];
    for (let i = 0; i < transferRoutes.length; i++) {
      let transferRoute = transferRoutes[i];
      if (transferRoute.sourceCurrency === sourceValue.currency) {
        if (!allowedTargetCurrencies.includes(transferRoute.targetCurrency)) {
          if (transferRoute.targetCurrency == "SGD") {
            prioritizeCurrencies[0] = "SGD";
          } else if (transferRoute.targetCurrency == "CNY") {
            prioritizeCurrencies[1] = "CNY";
          }  else if (transferRoute.targetCurrency == "MYR") {
            prioritizeCurrencies[2] = "MYR";
          } else if (transferRoute.targetCurrency == "IDR") {
            prioritizeCurrencies[3] = "IDR";
          } else if (transferRoute.targetCurrency == "USD") {
            prioritizeCurrencies[4] = "USD";
          } else {
            allowedTargetCurrencies.push(transferRoute.targetCurrency);
          }
        }
      }
    }
    prioritizeCurrencies = prioritizeCurrencies.filter(function (el) {
      return el != null;
    });
    allowedTargetCurrencies.sort();
    allowedTargetCurrencies = prioritizeCurrencies.concat(allowedTargetCurrencies);
    return allowedTargetCurrencies;
  };

  calculateTargetValueFromSourceValue(transferRoute, sourceValue, rates) {
    let fee = this.calculateFee(sourceValue.amount, transferRoute,  this.state.feeType, this.state.fixedFeeAmount);
    let convertAmount = sourceValue.amount - fee;
    if(transferRoute.feeCurrency != sourceValue.currency){
      convertAmount = sourceValue.amount;
    }
    let targetAmount = this.convert(
      convertAmount,
      sourceValue.currency,
      transferRoute.targetCurrency,
      rates
    );
    return { amount: targetAmount, currency: transferRoute.targetCurrency };
  }

  calculateSourceValueFromTargetValue(
    transferRoute,
    sourceCurrency,
    targetValue
  ) {
    let sourceAmount = this.convert(
      targetValue.amount,
      targetValue.currency,
      sourceCurrency,
      this.state.exchangeRates
    );
    if(transferRoute.feeCurrency != sourceCurrency){
      return { amount: sourceAmount, currency: sourceCurrency };
    }else{
      if(this.props.transfer.activeTabFee && this.props.transfer.activeTabFee === 'swift'){
        sourceAmount = sourceAmount + parseFloat(this.props.transfer.swiftFee);
      }else {
        if (this.state.feeType === "FIXED") {
          if (this.state.fixedFeeAmount != null) {
            sourceAmount = sourceAmount + parseFloat(this.state.fixedFeeAmount);
          }
        } else {
          // sourceAmount = sourceAmount * (1 + parseFloat(transferRoute.feePercent));
          let sourceAmountCalculateByConvertAmount = sourceAmount / (1 - transferRoute.feePercent);
          let minFee = this.state.minimumFeeFixedAmount;
          let feeValue = sourceAmountCalculateByConvertAmount * transferRoute.feePercent <= minFee ? minFee : sourceAmountCalculateByConvertAmount * transferRoute.feePercent;
          sourceAmount = sourceAmount + feeValue;
        }
      }

      return { amount: sourceAmount, currency: sourceCurrency };
    }
  }

  convert = (amount, fromCurrency, toCurrency, rates) => {

    if (this.state.transferMode === "SOURCE") {
      if (rates[fromCurrency] && rates[fromCurrency][toCurrency]) {
        return rates[fromCurrency][toCurrency] * amount;
      } else {
        return amount * 1.0 / rates[toCurrency][fromCurrency]
      }
    }else{
      if(rates[toCurrency]){
        return amount * 1.0 / rates[toCurrency][fromCurrency]
      }
    }
  };

  calculateFee = (sourceAmount, transferRoute,  feeType, fixedFeeAmount) => {


    if (!transferRoute) {
      return null;
    }
    if (this.props.transfer && this.props.transfer.activeTabFee === 'swift') {
      return this.props.transfer.swiftFee;
    } else {
      if (feeType === "FIXED") {
        return fixedFeeAmount;
      } else {
        let minFee = this.state.minimumFeeFixedAmount;
        let calculateFee = sourceAmount * transferRoute.feePercent;
        let feeValue = calculateFee <= minFee ? minFee : calculateFee;
        return feeValue;
      }
    }
  };
  // validationTransactionLimitation = () => {
  //   let transactionLimitations = this.state.transactionLimitation.filter(s => s.currency === this.state.targetValue.currency);
  //   if (transactionLimitations.length > 0) {
  //     let transactionLimitation = transactionLimitations[0];
  //     let targetAmount = this.state.targetValue.amount;
  //     if (targetAmount !== '' && this.props.currentCustomer != null) {
  //       if(this.props.currentCustomer.personalAccountDetails != null){
  //         return {
  //           result: targetAmount <= transactionLimitation.individualMax,
  //           max: transactionLimitation.individualMax
  //         };
  //       }else{
  //         return {
  //           result: targetAmount <= transactionLimitation.corporateMax,
  //           max: transactionLimitation.corporateMax
  //         };
  //       }
  //
  //     }
  //
  //   }
  //   return {result: true, max: ''};
  // };

  fireChanged = () => {
    let sourceValue = this.state.sourceValue;
    let targetValue = this.state.targetValue;
    let newTransferRoute = this.findTransferRoute(
        this.state.transferRoutes,
        sourceValue.currency,
        targetValue.currency
    );
    let currentUser = this.props.currentCustomer;
    let isPartner = null;
    if (currentUser && currentUser.customerTierName && currentUser.customerTierName.includes('PARTNER')) {
      isPartner=true;
    }
    this.setState({

      displaySelectBeneficiaryCountry: newTransferRoute.beneficiaryCountries && newTransferRoute.beneficiaryCountries.length > 1,
      displaySelectBeneficiaryType: !newTransferRoute.customizedRateAppliedSameForCorpAndIndividual && newTransferRoute.customizedRate !=null && newTransferRoute.type === 'RECEIVER',
      displaySelectSenderType: !newTransferRoute.customizedRateAppliedSameForCorpAndIndividual && newTransferRoute.customizedRate !=null && newTransferRoute.type === 'SENDER' && isPartner
    })
    // let validationLimit = this.validationTransactionLimitation();
    // let errorMsg = "";
    // const intl = this.props.useIntl;
    // let msg = intl.formatMessage({id: "app.panel.clienttransfercalculator.max.recipient"});
    // if (!validationLimit.result) {
    //     let currency = this.state.targetValue.currency;
    //     let validationLimitMax = validationLimit.max;
    //     errorMsg = msg + " " + currency + " " + displayNumberWithComma(validationLimitMax);
    //   this.setState({
    //     errorMsgOverLimit:errorMsg
    //   });
    // }else {
    //   this.setState({
    //     errorMsgOverLimit:''
    //   });
    // }

    let activeTabFee = null;
    let swiftFee = null;
    let selectedTransferRoute = this.state.selectedTransferRoute;
    let transferMode = this.state.transferMode;
    if(this.props.transfer){
      activeTabFee = this.props.transfer.activeTabFee;
      swiftFee = this.props.transfer.swiftFee;
      // targetValue =  this.calculateTargetAmountAfterChangeFee()
    }

    this.props.onChange({
      sourceValue: sourceValue,
      targetValue: targetValue,
      transactionLimitation: this.state.transactionLimitation,
      convertedAmount: this.getConvertedAmount(),
      transferRoute: selectedTransferRoute,
      transferMode: transferMode,
      beneficiaryType: this.state.beneficiaryType,
      senderType: this.state.senderType,
      beneficiaryCountry: this.state.beneficiaryCountry,
      displaySelectBeneficiaryType: !newTransferRoute.customizedRateAppliedSameForCorpAndIndividual && newTransferRoute.customizedRate !=null && newTransferRoute.type === 'RECEIVER',
      displaySelectSenderType: !newTransferRoute.customizedRateAppliedSameForCorpAndIndividual && newTransferRoute.customizedRate !=null && newTransferRoute.type === 'SENDER' && isPartner,
      displaySelectBeneficiaryCountry: newTransferRoute.beneficiaryCountries && newTransferRoute.beneficiaryCountries.length > 1,
      fee: this.calculateRemittanceFee(),
      exchangeRates:this.state.exchangeRates,
      activeTabFee: activeTabFee,
      swiftFee: swiftFee,
      indicativeOrder: newTransferRoute.indicativeOrder
    });
  

  };

  loadTransferCalculatorConfiguration = (activeTabFee) => {
    let tmpVal = undefined;
    if(activeTabFee) {
      tmpVal = activeTabFee;
    }else if(this.props.transfer && this.props.transfer.activeTabFee){
      tmpVal = this.props.transfer.activeTabFee;
    }
    getTransferCalculatorConfiguration(this.state.sourceValue.amount === undefined ? 1000 :  this.state.sourceValue.amount, null, this.state.beneficiaryType, this.state.beneficiaryCountry, this.state.senderType,
        tmpVal)
      .then(response => {

        if(this.state.initData){

          let currentUser = this.props.currentCustomer;
          let isPartner = null;
          if (currentUser && currentUser.customerTierName && currentUser.customerTierName.includes('PARTNER')) {
            isPartner=true;
          }
          let sourceDefaultCurrency ='SGD';
          let targetDefaultCurrency ='MYR';
          if(isPartner) {
            sourceDefaultCurrency='USD';
            targetDefaultCurrency ='USD';
          } else if (this.state.baseCurrency === 'HKD') {
            sourceDefaultCurrency = 'HKD';
            targetDefaultCurrency = 'USD';
          }
          else if (this.state.baseCurrency === 'SGD') {
            sourceDefaultCurrency = 'SGD';
            targetDefaultCurrency = 'MYR';
          }
          else if (this.state.baseCurrency === 'MYR') {
            sourceDefaultCurrency = 'MYR';
            targetDefaultCurrency = 'USD';
          }
          this.setState({
            initData:false,
          },()=>{
            let initialTransferRoute = response.transferRoutes.filter(s=>s.sourceCurrency === sourceDefaultCurrency &&
                s.targetCurrency ===targetDefaultCurrency)[0]

            if (initialTransferRoute.beneficiaryCountries && initialTransferRoute.beneficiaryCountries.length >= 1) {
              let tmpActiveTabFee = this.props.transfer ? this.props.transfer.activeTabFee:undefined;
              getTransferCalculatorConfiguration(this.state.sourceValue.amount === undefined ? 1000 :  this.state.sourceValue.amount,
                  null, this.state.beneficiaryType, initialTransferRoute.beneficiaryCountries[0] , this.state.senderType,tmpActiveTabFee).then(rs => {
                this.onConfigurationLoaded(rs);
                let currentDateTime = new Date();
                let dateTemp  = currentDateTime.toLocaleString("en-US", {timeZone: "Asia/Singapore"}, );

                this.setState({
                  isConfigurationLoading: false,
                  date: moment(dateTemp).format('DD MMMM YYYY'),
                  time: moment(dateTemp).format("hh:mm:ss A") + ' (GMT+8)'
                });
              });
            }else{
              this.onConfigurationLoaded(response);
              let currentDateTime = new Date();
              let dateTemp  = currentDateTime.toLocaleString("en-US", {timeZone: "Asia/Singapore"}, );

              this.setState({
                isConfigurationLoading: false,
                date: moment(dateTemp).format('DD MMMM YYYY'),
                time: moment(dateTemp).format("hh:mm:ss A") + ' (GMT+8)'
              });
            }


          })

        }else{
          this.onConfigurationLoaded(response);
          let currentDateTime = new Date();
          let dateTemp  = currentDateTime.toLocaleString("en-US", {timeZone: "Asia/Singapore"}, );

          this.setState({
            isConfigurationLoading: false,
            date: moment(dateTemp).format('DD MMMM YYYY'),
            time: moment(dateTemp).format("hh:mm:ss A") + ' (GMT+8)'
          });
        }

      })
      .catch(error => {
        this.setState({
          isConfigurationLoading: false
        });
      });
    // getTransactionLimitations().then(response => {
    //   this.setState({
    //     transactionLimitation: response
    //   })
    // }).catch(error => {
    //
    // });
  };

  findTransferRoute(transferRoutes, sourceCurrency, targetCurrency) {
    for (let i = 0; i < transferRoutes.length; i++) {
      if (
        transferRoutes[i].sourceCurrency === sourceCurrency &&
        transferRoutes[i].targetCurrency === targetCurrency
      ) {
        return transferRoutes[i];
      }
    }
    for (let i = 0; i < transferRoutes.length; i++) {
      if (transferRoutes[i].sourceCurrency === sourceCurrency) {
        return transferRoutes[i];
      }
    }
    return null;
  }

  onSourceAmountChanged = (newSourceValue, changeType) => {

    let newTransferMode = "SOURCE";
    this.setState({
      transferMode: newTransferMode,
    },()=>{
      if(changeType === "CURRENCY" && newTransferMode === 'TARGET'){
        let newTransferRoute = this.findTransferRoute(
            this.state.transferRoutes,
            newSourceValue.currency,
            this.state.targetValue.currency
        );
        // calculation source amount base on targetAmount
        let newSourceValueTemp = this.calculateSourceValueFromTargetValue(
            newTransferRoute,
            newSourceValue.currency,
            this.state.targetValue
        );
        //re calculate source amount after can get rate and fee from source amount
        if(!isNaN(newSourceValueTemp.amount)){
          this.calculateSourceAmountOrTargetAmountWhenSourceChanged(newSourceValueTemp.amount, newSourceValue, changeType)
        }
      }else{

          if(!isNaN(newSourceValue.amount)){
          this.calculateSourceAmountOrTargetAmountWhenSourceChanged(newSourceValue.amount, newSourceValue, changeType)
        }
      }
    })



  };

  calculateTargetAmountAfterChangeFee = () =>{
    let transferMode = this.state.transferMode;
    let transferRoute = this.state.selectedTransferRoute;
    let sourceValue = this.state.sourceValue;
    let newTargetValue = null;
    if (transferMode === "SOURCE") {
      newTargetValue = this.calculateTargetValueFromSourceValue(
          transferRoute,
          sourceValue,
          this.state.exchangeRates
      );
    } else if (transferMode === "TARGET") {
      newTargetValue = this.state.targetValue;
      sourceValue = this.calculateSourceValueFromTargetValue(
          transferRoute,
          sourceValue.currency,
          newTargetValue
      );
    }

    if(["JPY","IDR","VND","KRW"].includes(newTargetValue.currency)) {
      newTargetValue.amount =  Math.round(newTargetValue.amount);
    }

    if(["JPY","IDR","VND","KRW"].includes(sourceValue.currency)) {
      sourceValue.amount =  Math.round(sourceValue.amount);
    }
    // return newTargetValue;
    this.setState(
        {
          sourceValue: sourceValue,
          targetValue: newTargetValue,
        },
        function () {
          this.fireChanged();
        }
    );
  }

  calculateSourceAmountOrTargetAmountWhenSourceChanged =(amount, newSourceValue, changeType) => {
    let newTransferMode =
        changeType === "CURRENCY" ? this.state.transferMode : "SOURCE";
    getTransferCalculatorConfiguration(amount, null, this.state.beneficiaryType, this.state.beneficiaryCountry,  this.state.senderType,
        this.props.transfer?this.props.transfer.activeTabFee:undefined
        ).then(response => {
      let newTransferRoute = this.findTransferRoute(response.transferRoutes, newSourceValue.currency, this.state.targetValue.currency);
      //incase customized rate setup for multiple country
      if (newTransferRoute.beneficiaryCountries && newTransferRoute.beneficiaryCountries.length >= 1) {
        let countries = this.state.countries.filter(s => newTransferRoute.beneficiaryCountries.includes(s.countryCode))

        this.setState({
          beneficiaryCountries: countries,
            beneficiaryCountry:  changeType === "CURRENCY" ? newTransferRoute.beneficiaryCountries[0] : this.state.beneficiaryCountry
        },()=>{
          getTransferCalculatorConfiguration(amount, null, this.state.beneficiaryType, this.state.beneficiaryCountry
              ,  this.state.senderType,
              this.props.transfer?this.props.transfer.activeTabFee:undefined).then(response => {

            let newTransferRoute = this.findTransferRoute(response.transferRoutes, newSourceValue.currency, this.state.targetValue.currency);
            this.setState({
              transferMode: newTransferMode,
              feeType: newTransferRoute.feeType,
              fixedFeeAmount: newTransferRoute.feeFixed,
              minimumFeeFixedAmount:newTransferRoute.minimumFeeFixed,
              exchangeRates: Object.assign(this.state.exchangeRates, response.regularRates),
              transferRoutes:response.transferRoutes,
            }, () => {

              let newTargetValue = null;
              let allowedTargetCurrencies = this.calculateAllowedTargetCurrencies(
                  this.state.transferRoutes,
                  newSourceValue
              );
              if (newTransferMode === "SOURCE") {
                newTargetValue = this.calculateTargetValueFromSourceValue(
                    newTransferRoute,
                    newSourceValue,
                    this.state.exchangeRates
                );
              } else if (newTransferMode === "TARGET") {
                newTargetValue = this.state.targetValue;
                newSourceValue = this.calculateSourceValueFromTargetValue(
                    newTransferRoute,
                    newSourceValue.currency,
                    newTargetValue
                );
              }

              if(["JPY","IDR","VND","KRW"].includes(newTargetValue.currency)) {
                newTargetValue.amount =  Math.round(newTargetValue.amount);
              }

              if(["JPY","IDR","VND","KRW"].includes(newSourceValue.currency)) {
                newSourceValue.amount =  Math.round(newSourceValue.amount);
              }

              this.setState(
                  {
                    sourceValue: newSourceValue,
                    targetValue: newTargetValue,
                    allowedTargetCurrencies: allowedTargetCurrencies,
                    //allowedTargetCurrencies: BETA_TARGET_CURRENCY,
                    selectedTransferRoute: newTransferRoute,
                    transferMode: newTransferMode
                  },
                  function () {
                    this.fireChanged();
                  }
              );
            })

          })
        })

        }else{
        this.setState({
          transferMode: newTransferMode,
          feeType: newTransferRoute.feeType,
          fixedFeeAmount: newTransferRoute.feeFixed,
          minimumFeeFixedAmount:newTransferRoute.minimumFeeFixed,
          exchangeRates: Object.assign(this.state.exchangeRates, response.regularRates),
          transferRoutes:response.transferRoutes,
        }, () => {

          let newTargetValue = null;
          let allowedTargetCurrencies = this.calculateAllowedTargetCurrencies(
              this.state.transferRoutes,
              newSourceValue
          );
          if (newTransferMode === "SOURCE") {
            newTargetValue = this.calculateTargetValueFromSourceValue(
                newTransferRoute,
                newSourceValue,
                this.state.exchangeRates
            );
          } else if (newTransferMode === "TARGET") {
            newTargetValue = this.state.targetValue;
            newSourceValue = this.calculateSourceValueFromTargetValue(
                newTransferRoute,
                newSourceValue.currency,
                newTargetValue
            );
          }

          if(["JPY","IDR","VND","KRW"].includes(newTargetValue.currency)) {
            newTargetValue.amount =  Math.round(newTargetValue.amount);
          }

          if(["JPY","IDR","VND","KRW"].includes(newSourceValue.currency)) {
            newSourceValue.amount =  Math.round(newSourceValue.amount);
          }

          this.setState(
              {
                sourceValue: newSourceValue,
                targetValue: newTargetValue,
                allowedTargetCurrencies: allowedTargetCurrencies,
                //allowedTargetCurrencies: BETA_TARGET_CURRENCY,
                selectedTransferRoute: newTransferRoute,
                transferMode: newTransferMode,
                beneficiaryCountry: ''
              },
              function () {
                this.fireChanged();
              }
          );
        })
      }
    });

  }

  onTargetAmountChanged = (newTargetValue, changeType) => {

    if (newTargetValue === this.state.targetValue) {
      return;
    }
    let newTransferMode =
        changeType === "CURRENCY" ? "SOURCE" : "TARGET";
    this.setState({
      transferMode: newTransferMode,
    },()=>{
      if(changeType === "CURRENCY" && newTransferMode === 'SOURCE'){
        this.calculateSourceAmountOrTargetAmountWhenTargetChanged(this.state.sourceValue.amount, newTargetValue, changeType);
      }else{

        let newTransferRoute = this.findTransferRoute(
            this.state.transferRoutes,
            this.state.sourceValue.currency,
            newTargetValue.currency
        );
        // calculation source amount base on targetAmount
        let newSourceValue = this.calculateSourceValueFromTargetValue(
            newTransferRoute,
            this.state.sourceValue.currency,
            newTargetValue
        );
        //re calculate source amount after can get rate and fee from source amount
        if(!isNaN(newSourceValue.amount)){
          this.calculateSourceAmountOrTargetAmountWhenTargetChanged(newSourceValue.amount, newTargetValue, changeType);
        }
      }

    })
  };
  calculateSourceAmountOrTargetAmountWhenTargetChanged = (amount, newTargetValue, changeType) => {
    let newTransferMode =
        changeType === "CURRENCY" ? this.state.transferMode : "TARGET";
    let convertedAmount = this.convert(
        newTargetValue.amount,
        newTargetValue.currency,
        this.state.sourceValue.currency,
        this.state.exchangeRates
    );
    getTransferCalculatorConfigurationWithConvertAmount(amount, null, this.state.beneficiaryType, null, convertedAmount
        ,  this.state.senderType, this.props.transfer ? this.props.transfer.activeTabFee : undefined).then(response => {
      let newTransferRoute = this.findTransferRoute(
          response.transferRoutes,
          this.state.sourceValue.currency,
          newTargetValue.currency
      );
      //incase customized rate setup for multiple country
      if (newTransferRoute.beneficiaryCountries && newTransferRoute.beneficiaryCountries.length >= 1) {
        let countries = this.state.countries.filter(s => newTransferRoute.beneficiaryCountries.includes(s.countryCode))
        this.setState({
          beneficiaryCountries: countries,
          beneficiaryCountry:  changeType === "CURRENCY" ? newTransferRoute.beneficiaryCountries[0] : this.state.beneficiaryCountry,
        },()=>{
          getTransferCalculatorConfigurationWithConvertAmount(amount, null, this.state.beneficiaryType, this.state.beneficiaryCountry, convertedAmount
              ,  this.state.senderType,this.props.transfer ? this.props.transfer.activeTabFee : undefined).then(response => {
            let newTransferRoute = this.findTransferRoute(
                response.transferRoutes,
                this.state.sourceValue.currency,
                newTargetValue.currency
            );

            this.setState({
              transferMode: newTransferMode,
              feeType: newTransferRoute.feeType,
              fixedFeeAmount: newTransferRoute.feeFixed,
              minimumFeeFixedAmount:newTransferRoute.minimumFeeFixed,
              exchangeRates: Object.assign(this.state.exchangeRates, response.regularRates),
              transferRoutes:response.transferRoutes,
            }, () => {
              let newSourceValue;
              if (newTransferMode === "SOURCE") {
                newSourceValue = this.state.sourceValue;
                newTargetValue = this.calculateTargetValueFromSourceValue(
                    newTransferRoute,
                    newSourceValue,
                    this.state.exchangeRates
                );
              } else if (newTransferMode === "TARGET") {
                newSourceValue = this.calculateSourceValueFromTargetValue(
                    newTransferRoute,
                    this.state.sourceValue.currency,
                    newTargetValue
                );
              }
              let selectedTransferRoute = this.findTransferRoute(
                  this.state.transferRoutes,
                  newSourceValue.currency,
                  newTargetValue.currency
              );

              if(["JPY","IDR","VND","KRW"].includes(newTargetValue.currency)) {
                newTargetValue.amount =  Math.round(newTargetValue.amount);
              }

              if(["JPY","IDR","VND","KRW"].includes(newSourceValue.currency)) {
                newSourceValue.amount =  Math.round(newSourceValue.amount);
              }

              this.setState(
                  {
                    targetValue: newTargetValue,
                    sourceValue: newSourceValue,
                    transferMode: newTransferMode,
                    selectedTransferRoute: selectedTransferRoute
                  },
                  function() {
                    this.fireChanged();
                  }
              );
            });

          })
        });


      }else{
        this.setState({
          transferMode: newTransferMode,
          feeType: newTransferRoute.feeType,
          fixedFeeAmount: newTransferRoute.feeFixed,
          minimumFeeFixedAmount:newTransferRoute.minimumFeeFixed,
          exchangeRates: Object.assign(this.state.exchangeRates, response.regularRates),
          transferRoutes:response.transferRoutes,
        }, () => {
          let newSourceValue;
          if (newTransferMode === "SOURCE") {
            newSourceValue = this.state.sourceValue;
            newTargetValue = this.calculateTargetValueFromSourceValue(
                newTransferRoute,
                newSourceValue,
                this.state.exchangeRates
            );
          } else if (newTransferMode === "TARGET") {
            newSourceValue = this.calculateSourceValueFromTargetValue(
                newTransferRoute,
                this.state.sourceValue.currency,
                newTargetValue
            );
          }
          let selectedTransferRoute = this.findTransferRoute(
              this.state.transferRoutes,
              newSourceValue.currency,
              newTargetValue.currency
          );

          if(["JPY","IDR","VND","KRW"].includes(newTargetValue.currency)) {
            newTargetValue.amount =  Math.round(newTargetValue.amount);
          }

          if(["JPY","IDR","VND","KRW"].includes(newSourceValue.currency)) {
            newSourceValue.amount =  Math.round(newSourceValue.amount);
          }

          this.setState(
              {
                targetValue: newTargetValue,
                sourceValue: newSourceValue,
                transferMode: newTransferMode,
                selectedTransferRoute: selectedTransferRoute,
                beneficiaryCountry: ''
              },
              function() {
                this.fireChanged();
              }
          );
        });
      }


    })
  }

  calculateRemittanceFee = () => {
    return this.calculateFee(
      this.state.sourceValue.amount,
      this.state.selectedTransferRoute,
      this.state.feeType,
      this.state.fixedFeeAmount
    );
  };

  getExchangeRate = transferRoute => {
    if (!transferRoute) {
      return null;
    }

    let result = this.state.exchangeRates[transferRoute.sourceCurrency][
        transferRoute.targetCurrency
        ];
    return result;
  };

  getConvertedAmount = () => {
    if (!this.state.selectedTransferRoute) {
      return null;
    }
    let fee = this.calculateFee(
      this.state.sourceValue.amount,
      this.state.selectedTransferRoute,
        this.state.feeType, this.state.fixedFeeAmount
    );
    if(this.state.selectedTransferRoute.feeCurrency != this.state.sourceValue.currency){
      return this.state.sourceValue.amount;
    }
    let result = this.state.sourceValue.amount - fee;
    if(result<0)
      return "0.00";
    return result;
  };

  getArrivalEstimation = transferRoute => {
    if (!transferRoute) {
      return null;
    }
    return transferRoute.deliveryEstimationDays;
  };
  onChangeSenderType =(senderType)=> {
    this.setState(
        {
          senderType : senderType,
        },
        function() {
          this.loadTransferCalculatorConfiguration();
        }
    );
  }
  onChangeBeneficiaryType =(beneficiaryType)=> {
    this.setState(
        {
          beneficiaryType : beneficiaryType,
        },
        function() {
          this.loadTransferCalculatorConfiguration();
        }
    );
  }
  onChangeBeneficiaryCountry =(beneficiaryCountry)=> {
    this.setState(
        {
          beneficiaryCountry : beneficiaryCountry,
        },
        function() {
          this.loadTransferCalculatorConfiguration();
        }
    );
  }
  render() {
    const radioStyle = {
      height: "30px",
      lineHeight: "30px"
    };
    const intl = this.props.useIntl;
    if (this.state.isConfigurationLoading) {
      return <LoadingIndicator />;
    }
    let fee = this.calculateRemittanceFee();
    return (
      <div className="transfer-calculator">
        <Row className={"amount-panel"}>
          <Col md={11} className={"col-source-amount"}>
            <MoneyInputWithCurrencySelector
              title={intl.formatMessage({id: "app.panel.clienttransfercalculator.yousend"})}
              placeholder={intl.formatMessage({id: "app.panel.clienttransfercalculator.sourceamount"})}
              value={this.state.sourceValue}
              allowedCurrencies={this.state.allowedSourceCurrencies}
              minValue={fee + SEND_AMOUNT_MIN}
              maxValue={SEND_AMOUNT_MAX}
              onChange={this.onSourceAmountChanged}
            />
          </Col>
          <Col className={"bridge-line"} md={3}>
            <span />
          </Col>
          <Col md={10} className={"col-target-amount"}>
            <MoneyInputWithCurrencySelector
                targetField={true}
              title={intl.formatMessage({id: "app.panel.clienttransfercalculator.recipientgets"})}
              className="currency-selector"
              placeholder={intl.formatMessage({id: "app.panel.clienttransfercalculator.targetamount"})}
              value={this.state.targetValue}
              onChange={this.onTargetAmountChanged}
              allowedCurrencies={this.state.allowedTargetCurrencies}
              errorMsgOverLimit={this.props.errorMsgOverLimit}
            />

          </Col>
          <Col md={14}>   {this.state.displaySelectSenderType && (
              <RadioGroup
                  className={"bp-radio-custom"}
                  defaultValue={this.state.senderType}
                  onChange={event => this.onChangeSenderType(event.target.value)}>
            <span>
            <Radio value="PERSONAL">
                  Personal
                </Radio>
            </span><span>
            <Radio value="CORPORATE">
                Corporate
            </Radio>
          </span>
              </RadioGroup>)}</Col>
          <Col md={10} className={"recipient-type"}>
            {this.state.displaySelectBeneficiaryType && (
          <RadioGroup
                className={"bp-radio-custom"}
                defaultValue={this.state.beneficiaryType}
                onChange={event => this.onChangeBeneficiaryType(event.target.value)}>
            <span>
            <Radio value="PERSONAL">
                  Personal
                </Radio>
            </span><span>
            <Radio value="CORPORATE">
                Corporate
            </Radio>
          </span>
            </RadioGroup>)}

            {this.state.displaySelectBeneficiaryCountry && (
                <BrdgxCountrySelector
                    placeholder={intl.formatMessage({id: "app.modal.beneficiarymodal.selectcountry"})}
                    style={{width: '100%'}}
                    size={"large"}
                    name="country"
                    countries={this.state.beneficiaryCountries}
                    value={this.state.beneficiaryCountry}
                    onChange={country =>
                        this.onChangeBeneficiaryCountry(country)
                    }
                />

              )}
          </Col>
          <Col md={24} className={"col-transfer-detail"}>
            <TransferDetailsPanel
              factors={this.state.factors}
              sourceValue={this.state.sourceValue}
              targetValue={this.state.targetValue}
              fee={fee}
              transfer={this.props.transfer}
              transferRoute={this.state.selectedTransferRoute}
              exchangeRate={this.getExchangeRate(
                this.state.selectedTransferRoute
              )}
              updateSwiftFee = {(swiftFee,activeTabFee,dbsChargeBearer) => {
                this.props.updateSwiftFee(swiftFee,activeTabFee,dbsChargeBearer);
                this.loadTransferCalculatorConfiguration(activeTabFee);
              }}
              updatePaymentActiveTabFee={(activeTabFee)=>{
                this.props.updatePaymentActiveTabFee(activeTabFee);
                this.loadTransferCalculatorConfiguration(activeTabFee);
              }}
              updateSourceTargetAfterChangeFee={()=>{
                this.calculateTargetAmountAfterChangeFee();
              }}
              convertedAmount={this.getConvertedAmount()}
              arrivalEstimation={this.getArrivalEstimation(
                this.state.selectedTransferRoute
              )}
            />
          </Col>
        </Row>
       {/* <Form.Item label={<label style={{ color:  this.props.lableColor ? this.props.lableColor : "black", fontWeight: "bold" }}>
          <FormattedMessage id="app.panel.clienttransfercalculator.recipient.type"/>
        </label>}>
        </Form.Item>*/}
        {/*<div className="transfer-details-panel-sm">
        <Row className={"amount-panel"} justify={"center"}>
          <Col span={24}>
          <RadioGroup
              className={"bp-radio-custom"}
              defaultValue={this.state.beneficiaryType}
              onChange={event => this.onChangeBeneficiaryType(event.target.value)}>
            <span>
            <Radio value="PERSONAL">
                  Personal
                </Radio>
            </span><span>
            <Radio value="CORPORATE">
                Corporate
            </Radio>
          </span>
          </RadioGroup>
          </Col>
        </Row>
        </div>*/}
        <div style={{marginTop:'10px'}}>
            <FormattedMessage id="app.panel.clienttransfercalculator.updated"/>{' '}<span className="transfer-calculator-timestamp-full"><Icon style={{marginLeft: '10px'}} type="dashboard"></Icon></span><span
            style={{marginLeft: '7px'}}>
             {this.state.time}</span>
          <span style={{marginLeft: '15px'}} className="transfer-calculator-timestamp-full"> {this.state.date}</span>
        </div>
      </div>
    );
  }
}

export default withUseIntl(ClientTransferCalculator);